export default __webpack_public_path__ + "static/media/logo-ae-sivvi.5a09951b.svg";